import React from 'react';
import PropTypes from 'prop-types';
import SvgSymbol from 'common/components/svg-symbol';
import {getIconName} from 'common/utils/resource-icon-util';
import './index.scss';

export default class StoryboardChapterIcon extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    style: PropTypes.object,
    type: PropTypes.string,
  };

  static defaultProps = {
    active: false,
    style: {},
    type: '',
  };

  getBackgroundIconName(active) {
    return `storyboard-background-${active ? 'active' : 'inactive'}`;
  }

  render() {
    const backgroundIconName = this.getBackgroundIconName(this.props.active);
    const iconName = getIconName(this.props.type);
    return (
      <div className={'StoryboardChapterIcon'} style={this.props.style}>
        <SvgSymbol name={backgroundIconName} />
        <SvgSymbol name={iconName} />
      </div>
    );
  }
}
